import { Link } from 'react-router-dom';

const words = ['恋爱小料', '心动瞬间', '官宣现场', '情侣小事', '甜味瓜', '不扎心的糖', '嘴角上扬', '甜瓜日报'];

export default function MarqueeBar() {
  const row = [...words, ...words];
  return (
    <div className="w-full border-y border-background-200 bg-secondary-950 overflow-hidden">
      <div className="flex whitespace-nowrap py-3 tx-marquee">
        {row.map((w, i) => (
          <span key={`${w}-${i}`} className="mx-5 flex items-center gap-5 text-xs md:text-sm text-secondary-200">
            {w}
            <i className="ri-heart-3-fill text-primary-400 text-[10px]" aria-hidden="true"></i>
          </span>
        ))}
      </div>
    </div>
  );
}